import {
    faCircleCheck,
    faCircleDollar,
    faHourglass,
    faLock,
    faThumbsDown,
    faThumbsUp,
} from "@fortawesome/pro-light-svg-icons"
import { MeetingServiceOrderStatus, DeliveryStatusInfo, FilteredStatuses } from "./meetingServiceTypes"
import type { StandardChipVariantType } from "../../../../../shared/components/badges/StandardChip"
import { tailwindPalette } from "../../../../theme/tailwindPalette"

export const STATUS_MAP: Record<FilteredStatuses, DeliveryStatusInfo> = {
    [MeetingServiceOrderStatus.NOT_APPROVED]: {
        statusItemLabel: "Not approved",
        label: "Unapprove",
        icon: faHourglass,
        bgColor: tailwindPalette.amber[50],
        textColor: tailwindPalette.amber[700],
        borderColor: tailwindPalette.amber[300],
        actionTranslationId: "service-center-admin-organization-resources-status-menu-not-approved",
        stateTranslationId: "service-center-admin-organization-resources-status-not-approved",
    },
    [MeetingServiceOrderStatus.APPROVED]: {
        statusItemLabel: "Approved",
        label: "Approve",
        icon: faThumbsUp,
        bgColor: tailwindPalette.green[50],
        textColor: tailwindPalette.green[700],
        borderColor: tailwindPalette.green[300],
        actionTranslationId: "service-center-admin-organization-resources-status-menu-approved",
        stateTranslationId: "service-center-admin-organization-resources-status-approved",
    },
    [MeetingServiceOrderStatus.REJECTED]: {
        statusItemLabel: "Rejected",
        label: "Reject",
        icon: faThumbsDown,
        bgColor: tailwindPalette.red[50],
        textColor: tailwindPalette.red[700],
        borderColor: tailwindPalette.red[300],
        actionTranslationId: "service-center-admin-organization-resources-status-menu-rejected",
        stateTranslationId: "service-center-admin-organization-resources-status-rejected",
    },
    [MeetingServiceOrderStatus.LOCKED]: {
        statusItemLabel: "Locked",
        label: "Lock",
        icon: faLock,
        bgColor: tailwindPalette.blue[50],
        textColor: tailwindPalette.blue[700],
        borderColor: tailwindPalette.blue[300],
        actionTranslationId: "service-center-admin-organization-resources-status-menu-locked",
        stateTranslationId: "service-center-admin-organization-resources-status-locked",
    },
    [MeetingServiceOrderStatus.PREPARING]: {
        statusItemLabel: "Preparing",
        label: "Preparing",
        icon: faLock,
        bgColor: tailwindPalette.blue[50],
        textColor: tailwindPalette.blue[700],
        borderColor: tailwindPalette.blue[300],
        actionTranslationId: "service-center-admin-organization-resources-status-menu-preparing",
        stateTranslationId: "service-center-admin-organization-resources-status-preparing",
    },
    [MeetingServiceOrderStatus.DELIVERED]: {
        statusItemLabel: "Delivered",
        label: "Delivered",
        icon: faCircleCheck,
        bgColor: tailwindPalette.green[50],
        textColor: tailwindPalette.green[700],
        borderColor: tailwindPalette.green[300],
        actionTranslationId: "service-center-admin-organization-resources-status-menu-delivered",
        stateTranslationId: "service-center-admin-organization-resources-status-delivered",
    },
    [MeetingServiceOrderStatus.BOOKED]: {
        statusItemLabel: "Booked",
        label: "Book",
        icon: faCircleDollar,
        bgColor: tailwindPalette.slate[50],
        textColor: tailwindPalette.slate[700],
        borderColor: tailwindPalette.slate[300],
        actionTranslationId: "service-center-admin-organization-resources-status-menu-booked",
        stateTranslationId: "service-center-admin-organization-resources-status-booked",
    },
    [MeetingServiceOrderStatus.READY]: {
        statusItemLabel: "Ready",
        label: "Ready",
        icon: faCircleCheck,
        bgColor: tailwindPalette.green[50],
        textColor: tailwindPalette.green[700],
        borderColor: tailwindPalette.green[300],
        actionTranslationId: "service-center-admin-organization-resources-status-menu-ready",
        stateTranslationId: "service-center-admin-organization-resources-status-menu-ready",
    },
    [MeetingServiceOrderStatus.COMPLETED]: {
        statusItemLabel: "Completed",
        label: "Complete",
        icon: faCircleCheck,
        bgColor: tailwindPalette.slate[50],
        textColor: tailwindPalette.slate[700],
        borderColor: tailwindPalette.slate[300],
        actionTranslationId: "service-center-admin-organization-resources-status-menu-completed",
        stateTranslationId: "service-center-admin-organization-resources-status-completed",
    },
    [MeetingServiceOrderStatus.DEFAULT]: {
        statusItemLabel: "No status",
        label: "No status",
        icon: faLock,
        disabled: true,
        bgColor: tailwindPalette.gray[50],
        textColor: tailwindPalette.gray[700],
        borderColor: tailwindPalette.gray[300],
        actionTranslationId: "service-center-admin-organization-resources-status-menu-default",
        stateTranslationId: "service-center-admin-organization-resources-status-menu-default",
    },
}

/** Read-only rendering of a status: the closest StandardChip variant to the STATUS_MAP colours above. */
export const STATUS_CHIP_VARIANT: Record<FilteredStatuses, StandardChipVariantType> = {
    [MeetingServiceOrderStatus.NOT_APPROVED]: "yellow",
    [MeetingServiceOrderStatus.APPROVED]: "success",
    [MeetingServiceOrderStatus.REJECTED]: "red",
    [MeetingServiceOrderStatus.LOCKED]: "info",
    [MeetingServiceOrderStatus.PREPARING]: "info",
    [MeetingServiceOrderStatus.DELIVERED]: "success",
    [MeetingServiceOrderStatus.BOOKED]: "grey",
    [MeetingServiceOrderStatus.READY]: "success",
    [MeetingServiceOrderStatus.COMPLETED]: "grey",
    [MeetingServiceOrderStatus.DEFAULT]: "grey",
}
